/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



var radios = document.querySelectorAll('input[type=radio][name="contact[model-confirm]"]');
var year_radios = document.querySelectorAll('input[type=radio][name="contact[year-confirm]"]');
function changeHandler(event) {
  console.log('selector = '+this.getAttribute('div_name'));
  var selector = this.getAttribute('div_name');
   if ( this.value == 'Yes' ) {
     document.querySelector('.'+selector).style.display="block";
     document.querySelector('.'+selector).nextElementSibling.classList.add('full-width');
      document.querySelector('.'+selector).nextElementSibling.nextElementSibling.classList.remove('full-width');
     console.log('value', 'allot');
   } else {
      console.log('value', 'transfer');
     document.querySelector('.'+selector).style.display="none";
     document.querySelector('.'+selector).nextElementSibling.classList.remove('full-width');
     document.querySelector('.'+selector).nextElementSibling.nextElementSibling.classList.add('full-width');
   }  
}
Array.prototype.forEach.call(radios, function(radio) {
   radio.addEventListener('change', changeHandler);
});

function changeHandlerNew(event) {
  console.log('selector = '+this.getAttribute('div_name'));
  var selector = this.getAttribute('div_name');
   if ( this.value == 'Yes' ) {
     document.querySelector('.'+selector).style.display="block";
     this.closest('div.pop-row').classList.remove('full-width');
     // document.querySelector('.'+selector).nextElementSibling.classList.remove('full-width');
     console.log('value', 'allot changeHandlerNew');
   } else {
      console.log('value', 'transfer');
     document.querySelector('.'+selector).style.display="none";
     this.closest('div.pop-row').classList.remove('full-width');
     // document.querySelector('.'+selector).nextElementSibling.classList.remove('full-width');
   }  
}
Array.prototype.forEach.call(year_radios, function(radio) {
   radio.addEventListener('change', changeHandlerNew);
});